import { render } from "./Partnerships.vue?vue&type=template&id=42f11fbf"
import script from "./Partnerships.vue?vue&type=script&lang=js"
export * from "./Partnerships.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__